import { useNavigate } from 'react-router-dom';
import { Footprints, PersonStanding } from 'lucide-react';

const BRISK_GOAL = 7000;
const STEPS_GOAL = 10000;

const MoveCard = ({ icon: Icon, label, value, goal, color, testId, onClick }) => {
  const pct = Math.min(100, Math.round(((value || 0) / goal) * 100));
  return (
    <button onClick={onClick} data-testid={testId} className="regen-card-elevated p-3.5 text-left active:scale-[0.98] transition-transform min-w-0">
      <div className="flex items-center gap-1.5">
        <Icon className="w-4 h-4 shrink-0" style={{ color }} />
        <span className="text-xs text-muted-foreground truncate">{label}</span>
      </div>
      <div className="font-mono text-xl sm:text-2xl mt-1.5">{value != null ? Number(value).toLocaleString() : '—'}</div>
      <div className="text-[10px] text-muted-foreground">of {goal.toLocaleString()} steps</div>
      <div className="h-1.5 mt-2 rounded-full bg-[var(--c-film)] overflow-hidden">
        <div className="h-full rounded-full transition-[width] duration-500" style={{ width: `${pct}%`, background: color }} />
      </div>
    </button>
  );
};

export const DailyMovement = ({ steps, brisk, briskGoal = BRISK_GOAL }) => {
  const nav = useNavigate();
  return (
    <div className="col-span-2 space-y-2.5" data-testid="daily-movement">
      <div className="grid grid-cols-2 gap-3">
        <MoveCard icon={PersonStanding} label="Brisk Walk" value={brisk} goal={briskGoal} color="#00C8FF" testId="health-brisk-walk" onClick={() => nav('/app/steps')} />
        <MoveCard icon={Footprints} label="Daily Steps" value={steps} goal={STEPS_GOAL} color="#65A30D" testId="health-steps" onClick={() => nav('/app/steps')} />
      </div>
      <p className="text-xs text-muted-foreground leading-snug" data-testid="movement-explainer">
        Brisk walking is purposeful activity. Daily steps include all movement throughout your day, including your brisk walk.
      </p>
      <div className="rounded-xl border border-[#65A30D]/30 bg-[#65A30D]/10 p-3.5 flex gap-3" data-testid="brisk-walk-recommendation">
        <span className="w-8 h-8 rounded-lg grid place-items-center shrink-0 bg-[#65A30D]/20 text-[var(--c-green-ink)]"><Footprints className="w-4 h-4" /></span>
        <div className="min-w-0">
          <div className="text-sm font-semibold">Your Daily Brisk Walk</div>
          <p className="text-xs text-muted-foreground mt-1 leading-relaxed">
            Aim for 7,000–10,000 steps a day, including a dedicated brisk walk — a purposeful pace that raises your heart rate, not
            just walking around the house. It supports cardiovascular and metabolic health and fat loss, including visceral fat over time.
            Gym sessions alone are not enough: make walking a daily habit. Consistency matters more than perfection.
          </p>
        </div>
      </div>
    </div>
  );
};
